import * as React from 'react';
import { EGDSHeading, EGDSSubheading } from '@egds/react-core/text';
import { EGDSIllustrations } from '@egds/react-core/illustrations';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { HeaderGuestHeadingActions } from './header-guest-heading-actions';
export var getReferrerPageLocation = function (locationPathname) {
  var referrerPageLocationValue = '';
  if (locationPathname.includes('Hotel-Information')) {
    referrerPageLocationValue = 'pdp';
  } else if (locationPathname.includes('Hotel-Search')) {
    referrerPageLocationValue = 'serp';
  } else {
    referrerPageLocationValue = 'homepage';
  }
  return "&referrer_page_location=".concat(referrerPageLocationValue);
};
export var redirectGssUrl = function (baseUrl, gssSigninRedirectParam, context, isSignOutLink, skipRedirectGss) {
  var _a;
  if (skipRedirectGss === void 0) {
    skipRedirectGss = false;
  }
  if (skipRedirectGss) {
    return baseUrl;
  }
  var queryParams = '';
  var VRBO_BRAND_NAME = 'vrbo';
  var brand = (_a = context === null || context === void 0 ? void 0 : context.site) === null || _a === void 0 ? void 0 : _a.brand;
  if (typeof window !== 'undefined' && window.location !== null) {
    var locationPathname = window.location && window.location.pathname;
    var locationSearch = window.location ? window.location.search : '';
    var locationHash = window.location ? window.location.hash : '';
    var returnUrl = locationPathname.concat(locationSearch, locationHash);
    if (brand !== VRBO_BRAND_NAME) {
      queryParams = "".concat(gssSigninRedirectParam).concat(encodeURIComponent(returnUrl));
    } else {
      var referrerPageLocation = getReferrerPageLocation(locationPathname);
      if (isSignOutLink) {
        queryParams = "".concat(encodeURIComponent(returnUrl));
      } else {
        queryParams = "".concat(referrerPageLocation).concat(gssSigninRedirectParam).concat(encodeURIComponent(returnUrl));
      }
    }
  }
  // We check for the presence of ? in baseUrl and append if it is not already present
  return baseUrl + ((baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.indexOf('?')) !== -1 ? '' : '?') + queryParams;
};
export var HeaderGuestHeading = function (_a) {
  var headerMenuIllustrationUrl = _a.headerMenuIllustrationUrl,
    headingText = _a.headingText,
    subHeadingText = _a.subHeadingText,
    buttons = _a.buttons,
    gssSigninRedirectParam = _a.gssSigninRedirectParam,
    context = _a.context;
  return React.createElement("div", {
    className: "header-guest-heading"
  }, React.createElement("div", {
    className: "heading-container"
  }, headerMenuIllustrationUrl && React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'three'
    }
  }, React.createElement(EGDSLayoutFlex, {
    justifyContent: "center"
  }, React.createElement(EGDSLayoutFlexItem, {
    maxWidth: "30x"
  }, React.createElement(EGDSIllustrations, {
    alt: headingText,
    url: headerMenuIllustrationUrl
  })))), React.createElement(EGDSHeading, {
    tag: "h2",
    size: 5
  }, headingText), subHeadingText && React.createElement(EGDSSubheading, null, subHeadingText), React.createElement(HeaderGuestHeadingActions, {
    gssSigninRedirectParam: gssSigninRedirectParam,
    buttons: buttons,
    context: context
  })));
};